import { Component, OnInit, inject } from '@angular/core';
import { WebAuthService } from '@rbb/ng-web-auth-lib';
import { environment } from '../../../environments/environment';
import { ProcessService } from '../../services/process.service';
import { EmployeeService } from '../../services/employee.service';
import { Employee } from '../../data/employee';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { Access } from '../../data/access';
import { AccessService } from '../../services/access.service';
import { NavbarConfig, VersionService, NavbarComponent as RbbNavbarComponent } from '@rbb/ng-web-template-lib';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  imports: [RouterLinkActive, RouterLink, RbbNavbarComponent]
})
export class NavbarComponent implements OnInit {
  webAuthService = inject(WebAuthService);
  private processService = inject(ProcessService);
  private employeeService = inject(EmployeeService);
  router = inject(Router);
  accessService = inject(AccessService);
  private versionService = inject(VersionService);

  approveCounter = 0;

  progressCounter = 0;
  employee: Employee | undefined;
  unauthorized = false;
  criticalFailure = false;
  receivedAccess: Access[] | undefined;

  version: string | undefined;
  navbarConfig: NavbarConfig = {
    title: environment.title,
    instance: environment.instance,
    userInfo: {
      getUsername: (): string | undefined => this.webAuthService.loggedIn ? this.webAuthService.authUser?.username : undefined,
      getFirstName: (): string | undefined => this.webAuthService.loggedIn ? this.webAuthService.authUser?.firstName : undefined,
      getLastName: (): string | undefined => this.webAuthService.loggedIn ? this.webAuthService.authUser?.lastName : undefined,
      getOrganisation: (): string | undefined => this.webAuthService.loggedIn ? this.webAuthService.authUser?.organisation : undefined
    },
    feedbackAppName: 'forms-web',
    getVersion: () => this.version,
    versionHistoryRouterLink: '/patch-notes',
    faqRouterLink: '/faq'
  };

  ngOnInit(): void {
    this.getEmployeeData();
    this.getReceivedAccess();
    this.versionService.getWebVersionInAssets()
      .subscribe(data => this.version = data.version);
  }

  getEmployeeData(): void {
    this.employeeService.getMyApprovers().subscribe({
      next: (next) => {
        this.employee = next;
        if (this.employee.notSapData && (!this.employee.orgUnit || !this.employee.costCentre)) {
          this.router.navigateByUrl('/my-data').then();
        } else {
          this.initReloadApproveCounter();
          this.initReloadProcessingCounter();
          this.processService.getToApproveObservable().subscribe(() => {
            this.getProcessesToApprove();
            this.getProcessesToProcessing();
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status && error.status >= 400 && error.status < 500) {
          this.unauthorized = true;
        } else {
          this.criticalFailure = true;
        }
      }
    });
  }

  getProcessesToApprove(): void {
    this.processService.countProcessesToApprove().subscribe(
      (data) => {
        this.approveCounter = data.number ?? 0;
      }
    );
  }

  getProcessesToProcessing(): void {
    this.processService.countProcessesToProcessing().subscribe(
      (data) => {
        this.progressCounter = data.number ?? 0;
      }
    );
  }

  initReloadApproveCounter(): void {
    this.getProcessesToApprove();
    setInterval(() => this.getProcessesToApprove(), 300000);
  }

  initReloadProcessingCounter(): void {
    this.getProcessesToProcessing();
    setInterval(() => this.getProcessesToProcessing(), 300000);
  }

  getReceivedAccess(): void {
    this.accessService.getReceivedAccess().subscribe(next => this.receivedAccess = next);
  }

  setAccess(access: Access | undefined): void {
    this.accessService.usernameContext = access?.username;
    this.accessService.usernameContextFirstName = access?.firstName;
    this.accessService.usernameContextLastName = access?.lastName;
    this.accessService.usernameContextToApprove = access?.toApprove;
    this.router.navigateByUrl('/list').then();
    this.getProcessesToApprove();
    this.getProcessesToProcessing();
  }
}
